import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function RequireAuth() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated) return <Outlet />;

  const next = `${location.pathname}${location.search || ''}`;
  return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
}

